import ExcelJS from "exceljs";
import React, { useEffect, useRef, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { SESSION_URLS } from "../../api/AdminUrls";
import ImportForm from "../../components/ImportForm";
import { useSiteContext } from "../../contexts/SiteProvider";
import { checkInterSection } from "../../services/core/FilterService";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import SessionUserAdditionForm from "./SessionUserAdditionForm";
import SessionUserEditForm from "./SessionUserEditForm";
import SessionuserSubform from "./SessionuserSubform";
import TraineeReport from "./TraineeReport";
import PdfViewer from "../../components/PdfViewer";
interface HeaderProps {
  session_id: number;
  idIn?: number;
  status_data: any;
}
const SessionUsersTable: React.FC<HeaderProps> = ({
  session_id,
  idIn,
  status_data,
}) => {
  const [tabData, setTabData] = useState([]);
  const { openModal, closeModal, user } = useSiteContext();
  const is_admin = checkInterSection(user?.roles || [], ["ADMIN", "AGENCY"]);
  const setCurrentPageRef = useRef<((page: number) => void) | null>(null);
  const currentPageRef = useRef<number>(1);
  const shouldRestorePageRef = useRef<boolean>(false);
  const loadTableDataWithRestore = () => {
    shouldRestorePageRef.current = true;
    loadTableData();
  };
  const loadTableData = () => {
    let URL = SESSION_URLS.GET_ALL_USERS;
    const subscription = post(URL, { id: session_id }).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };
  useEffect(() => {
    loadTableData();
  }, []);
  useEffect(() => {
    if (shouldRestorePageRef.current && setCurrentPageRef.current) {
      shouldRestorePageRef.current = false;
      setCurrentPageRef.current(currentPageRef.current);
    }
  }, [tabData]);

  const deleteData = (id: any) => {
    const subscription = post(SESSION_URLS.DELETE_USER, {
      session_user_id: id,
    }).subscribe((response) => {
      showAlertAutoClose("Deleted Successfully...", "success");
      closeModal();
      loadTableDataWithRestore();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Trainee Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Trainee? This action cannot be
          reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const viewEditForm = (id: any) => {
    let options = {
      title: "Loco Pilot Report",
      content: <TraineeReport id={id} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };

  const openEditForm = (data: any) => {
    let options = {
      title: "Edit Loco Pilot",
      content: (
        <SessionUserEditForm loadTableData={loadTableDataWithRestore} dataIn={data} />
      ),
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };

  const openOfficesForm = (data: any) => {
    let options = {
      title: (
        <>
          {data.ID ? "Loco Pilot Update Form" : "New Loco Pilot Addition Form"}
        </>
      ),
      content: (
        <SessionUserAdditionForm
          loadTableData={loadTableData}
          dataIn={data}
          session_id={session_id}
        />
      ),
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const resend_otp = (id: any) => {
    const subscription = post(SESSION_URLS.RESENT_OTP, {
      session_user_id: id,
    }).subscribe((response) => {
      showAlertAutoClose("OTP Sent Successfully...", "success");
      closeModal();
      loadTableDataWithRestore();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openResentModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Resend OTP!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          resend_otp(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you want to resend the OTP? The previous OTP will no longer
          be valid.
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const reworkTrainee = (id: any) => {
    const subscription = post(SESSION_URLS.REWORK_TRAINEE, {
      session_user_id: id,
    }).subscribe(() => {
      showAlertAutoClose("Rework assigned successfully...", "success");
      loadTableDataWithRestore();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openReworkModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-warning">
          <i className="fa fa-refresh"></i> Rework!
        </span>
      ),
      alertFunction: (option) => {
        if (option === "yes") {
          reworkTrainee(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>Do you want to assign rework to this Loco Pilot?</p>
      ),
      className: "custom-alert",
    };
    SmartAlert.show(alertProps);
  };

  // console.log("otp", resend_otp);
  const onSubmit = (dt: any) => {
    let url = SESSION_URLS.GET_TRAINEE_PDF;
    //console.log("id", dt, "url = ", url);
    const subscription = post(
      url,
      { session_user_id: dt["ID"] },
      { loadingMsg: "Downloading... please Wait" }
    ).subscribe((response) => {
      SdsFsDownloadFile(response.data.content, "Trainee Report.pdf");
    });

    return () => {
      subscription.unsubscribe();
    };
  };

    const downloadCretificate = (dt: any) => {
    let url = SESSION_URLS.GET_TRAINEE_CRITIFICATE;
    //console.log("id", dt, "url = ", url);
    const subscription = post(
      url,
      { session_user_id: dt["ID"] },
      { loadingMsg: "Downloading... please Wait" }
    ).subscribe((response) => {
      SdsFsDownloadFile(response.data.content, "Trainee Certificate.pdf");
    });

    return () => {
      subscription.unsubscribe();
    };
  };

   const ViewReport = (dt: any) => {
    let url = SESSION_URLS.GET_TRAINEE_PDF;
    //console.log("id", dt, "url = ", url);
    const subscription = post(
      url,
      { session_user_id: dt["ID"] },
      { loadingMsg: "Loading... please Wait" }
    ).subscribe((response) => {
      // SdsFsDownloadFile(response.data.content, "Trainee Report.pdf");
      viewReportForm(response.data.content)
    });

    return () => {
      subscription.unsubscribe();
    };
  };

  const viewSubFormForm = (data: any) => {
    let options = {
      title: "Practical Assessment",
      content: <SessionuserSubform status_data={status_data} data={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };

  

    const viewReportForm = (data: any) => {
    let options = {
      title: "Report",
      content: <PdfViewer base64={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 90,
    };
    openModal(options);
  };
  const updateAttendance = (id: any, value: number) => {
    const subscription = post(SESSION_URLS.UPDATE_ATTENDANCE, {
      session_user_id: id,
      day_two_status: value,
    }).subscribe(() => {
      showAlertAutoClose(
        value === 1 ? "Marked as Attended" : "Marked as Not Attended",
        "success"
      );
      shouldRestorePageRef.current = true;
      loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const openAttendanceModal = (data: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <div className="has-text-centered">
          <i className="fa fa-calendar-check-o fa-2x has-text-link mb-2"></i>
          <p className="is-size-5 has-text-weight-bold mt-1"> Day 2 </p>
        </div>
      ),
      alertFunction: (option) => {
        SmartAlert.hide();
        if (option === "yes") {
          updateAttendance(data["ID"], 1);
        } else if (option === "no") {
          updateAttendance(data["ID"], 2);
        }
      },
      content: (
        <div className="has-text-centered">
          <table className="table is-fullwidth is-bordered is-size-6 mb-3">
            <tbody>
              <tr>
                <th className="has-text-right" style={{ width: "45%" }}>Name</th>
                <td className="has-text-left"><strong>{data?.ename}</strong></td>
              </tr>
              <tr>
                <th className="has-text-right">Loco Pilot ID</th>
                <td className="has-text-left">{data?.euserid}</td>
              </tr>
              <tr>
                <th className="has-text-right">Mobile No</th>
                <td className="has-text-left">{data?.mobile_no}</td>
              </tr>
              <tr>
                <th className="has-text-right">Loco Shed</th>
                <td className="has-text-left">{data?.loco_shed}</td>
              </tr>
            </tbody>
          </table>
          <p className="is-size-6">
            Did <strong>{data?.ename}</strong> attend the <strong>Day 2</strong> session?
          </p>
        </div>
      ),
      buttons: [
        { index: "no", label: "No", icon: "fa fa-times", className: "is-danger" },
        { index: "yes", label: "Yes", icon: "fa fa-check", className: "is-success" },
      ],
      className: "custom-alert",
    };
    SmartAlert.show(alertProps);
  };

  const attendanceSwitchDisplay = (data_in: any) => {
    // if (data_in?.status !== "completed") return null;
    const isAttended = data_in?.day_two_status == 1;
    return (
      <label className="sds-toggle-switch" onClick={() => openAttendanceModal(data_in)}>
        <input type="checkbox" checked={isAttended} readOnly />
        <span className="slider"></span>
      </label>
    );
  };

  const viewSubForm_edit = (_dt: any) => {
    const subscription = post(SESSION_URLS.GET_PRACTICE_SESSION, {
      session_user_id: _dt["ID"],
      session_id: _dt["session_id"],
    }).subscribe((response: any) => {
      viewSubFormForm(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const buttons = [
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="Resend OTP">
          <i className="fa fa-mobile" />
        </span>
      ),
      classList: ["has-text-warning is-size-6 is-clickable"],
      onClick: (data: any) => {
        openResentModal(data["ID"]);
      },
      hideFunction: (data: any) => {
        if (is_admin) {
          return true;
        }
        if (
          status_data?.status &&
          status_data?.status.toLowerCase() === "completed"
        ) {
          return true;
        }
        return data["status"] == "in_progress" || data["status"] == "pending"
          ? false
          : true;
      },
    },
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="View Report">
          <i className="fa fa-eye" />
        </span>
      ),
      classList: ["has-text-info is-size-6 is-clickable"],
      onClick: (data: any) => ViewReport(data),
      hideFunction: (d: any) => d?.status !== "completed",
    },
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="Download Report">
          <i className="fa fa-download" />
        </span>
      ),
      classList: ["has-text-success is-size-6 is-clickable"],
      onClick: (data: any) => onSubmit(data),
      hideFunction: (d: any) => d?.status !== "completed",
    },
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="Download Certificate">
          <i className="fa fa-certificate" />
        </span>
      ),
      classList: ["has-text-danger is-size-6 is-clickable"],
      onClick: (data: any) => downloadCretificate(data),
      hideFunction: (d: any) => d?.status !== "completed",
    },
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="Rework">
          <i className="fa fa-refresh" />
        </span>
      ),
      classList: ["has-text-warning is-size-6 is-clickable"],
      onClick: (data: any) => openReworkModal(data["ID"]),
      hideFunction: (d: any) =>
        d?.status !== "completed" ||
        status_data?.status?.toLowerCase() !== "started" ||
        Number(d?.total_score) !== 0,
    },
    // {
    //   label: "",
    //   type: "icon",
    //   leftIconFunction: () => (
    //     <span className="icon" title="Practical Assessment">
    //       <i className="fa fa-tasks" />
    //     </span>
    //   ),
    //   classList: ["has-text-warning is-size-6 is-clickable"],
    //   onClick: (data: any) => {
    //     viewSubForm_edit(data);
    //   },
    //   hideFunction: (d: any) => is_admin || d?.status !== "completed",
    // },
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="Edit">
          <i className="fa fa-pencil" />
        </span>
      ),
      classList: ["has-text-primary is-size-6 is-clickable"],
      onClick: (data: any) => openEditForm(data),
      hideFunction: (d: any) => is_admin ,
      // hideFunction: (d: any) => {
      //   if (is_admin) return true;
      //   if (status_data?.status?.toLowerCase() === "completed") return true;
      //   return ["completed", "in_progress"].includes(d?.status);
      // },
    },
    {
      label: "",
      type: "icon",
      leftIconFunction: () => (
        <span className="icon" title="Delete">
          <i className="fa fa-trash" />
        </span>
      ),
      classList: ["has-text-danger is-size-6 is-clickable"],
      onClick: (data: any) => {
        openDeleteModal(data["ID"]);
      },
      hideFunction: () => true,
    },
  ];

  const exportexl = async (dataToExport: any[]) => {
    const title = "Loco Pilots Export";
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(title);

    const headers = [
      "S.NO",
      "Loco Pilot ID",
      "Name",
      "Mobile No",
      "Loco Shed",
      "Designation",
      "Reporting Place",
      "Status",
    ];

    worksheet.mergeCells(`A1:F1`);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "Loco Pilots List";
    titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "4472C4" },
    };

    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(2);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D9E1F2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    dataToExport.forEach((item, index) => {
      const row = [
        index + 1,
        item.euserid || "",
        item.ename || "",
        item.mobile_no || "",
        item.loco_shed || "",
        item.designation||"",
          item.reporting_place||"",
        item.status || "",
      ];

      const addedRow = worksheet.addRow(row);
      addedRow.eachCell((cell) => {
        cell.alignment = { vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    worksheet.columns.forEach((col) => {
      col.width = 20;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "LocoPilotExport.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scoreDisplay = (data_in: any) => {
    return <>{Math.trunc(Number(data_in?.total_score) || 0)}</>;
  };

  const statusTags = [
    { value: "started", label: "Started", class: "is-info" },
    { value: "active", label: "Active", class: "is-primary" },
    { value: "cancel", label: "Cancel", class: "is-danger" },
    { value: "completed", label: "Completed", class: "is-primary" },
  ];

  const statusDisplay = (data_in: any) => {
    const tag = statusTags.find((t) => t.value === data_in?.status);
    if (!tag) return <span className="tag is-light">{data_in?.status || ""}</span>;
    return <span className={`tag ${tag.class}`}>{tag.label}</span>;
  };

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    {
      title: "Name ",
      index: "ename",
    },
    {
      title: "Loco Pilot ID",
      index: "euserid",
    },
    {
      title: "Loco Shed",
      index: "loco_shed",
    },
    {
      title: "Mobile No",
      index: "mobile_no",
    },
        {
      title: "Reporting Place",
      index: "reporting_place",
    },
        {
      title: "designation",
      index: "designation",
    },
    {
      title: "OTP",
      index: "otp_pin",
    },
    {
      title: "Score (%)",
      index: "score",
      valueFunction: scoreDisplay,
    },
    {
      title: "Status",
      index: "status",
      valueFunction: statusDisplay,
    },
    ...(status_data?.status === "completed"
      ? [
          {
            title: "Day 2 Status",
            index: "attendance",
            valueFunction: attendanceSwitchDisplay,
            width: "8",
          },
        ]
      : []),
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },
  ];

  // const resultsTable = (data: any) => {
  //   const cols: any = [
  //     { title: "S.NO", index: "s_no", type: "sno", width: "5" },
  //     {
  //       title: "Employee ID",
  //       index: "euserid",
  //     },
  //     {
  //       title: "Name",
  //       index: "ename",
  //     },
  //     {
  //       title: "Mobile No",
  //       index: "mobile_no",
  //     },
  //     {
  //       title: "Loco Shed",
  //       index: "loco_shed",
  //     },
  //     {
  //       title: "Status",
  //       index: "status",
  //     },
  //     {
  //       title: "Message",
  //       index: "msg",
  //     },
  //   ];

  //   return (
  //     <SmartTable
  //       columns={cols}
  //       data={data}
  //       tableProps={{
  //         className: "is-hoverable is-bordered smart-hims-table",
  //         isResponsive: true,
  //       }}
  //       paginationProps={{ pageSize: 10 }}
  //     />
  //   );
  // };
  const resultsTable = (data: any) => {
    // ✅ Filter out only status === 5
    const visibleData = data.filter((item: any) => item.status !== 5);

    // ✅ Count based on visibleData
    const total = visibleData.length;
    const failed = visibleData.filter((item: any) => item.msg).length;
    const success = total - failed;

    const cols: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
      { title: "S.NO", index: "s_no", type: "sno", width: "5" },
      { title: "Employee ID", index: "euserid" },
      { title: "Name", index: "ename" },
      { title: "Mobile No", index: "mobile_no" },
      { title: "Loco Shed", index: "loco_shed" },
      { title: "Status", index: "status" },
      { title: "Message", index: "msg" },
    ];

    const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
      {
        type: "CUSTOM",
        widthClass: "is-12",
        custom: (
          <div className="is-flex is-justify-content-space-between is-align-items-center px-2 py-1">
            <span className="tag is-info is-light">Total: {total}</span>
            <span className="tag is-success is-light">Success: {success}</span>
            <span className="tag is-danger is-light">Failed: {failed}</span>
          </div>
        ),
      },
    ];

    return (
      <SmartTable
        columns={cols}
        data={visibleData}
        tableTop={tableTop}
        tableProps={{
          className: "is-hoverable is-bordered smart-hims-table",
          isResponsive: true,
        }}
        paginationProps={{ pageSize: 10 }}
      />
    );
  };

  const openImportModal = () => {
    const modalObject = {
      title: "Import Loco Pilot",
      content: (
        <ImportForm
          url={SESSION_URLS.IMPORT_EXCEL}
          loadData={loadTableData}
          resultsTable={resultsTable}
          subData={{ session_id: session_id }}
        />
      ),
      className: "sd-efl-modal",
      width: 60,
    };
    openModal(modalObject);
  };
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="is-size-4 has-text-weight-bold">Loco Pilots</p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
    {
      type: "CUSTOM",
      widthClass: "is-2",
      align: "CENTER",
      custom: (
        <div className="is-size-4">
          <span
            className="icon is-clickable excel-refresh-icon mx-3"
            onClick={loadTableData}
          >
            <i className="fa fa-refresh"></i>
          </span>

          <span
            className="icon ml-4 mx-3 is-clickable excel-export-icon"
            onClick={() => exportexl(tabData)}
            data-tooltip-id="export-tooltip"
            data-tooltip-content="Export"
          >
            <i className="fa fa-upload"></i>
          </span>
        </div>
      ),
    },
    {
      type: "BUTTONS",
      widthClass: "is-3",
      align: "CENTER",
      buttons: [
        // {
        //   type: "REFRESH",
        //   action: loadTableData,
        // },
        // {
        //   type: "EXPORT",
        //   label: "",
        //   className: "smart-third-button",
        // },
        {
          label: "Import",
          icon: "fa-download",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openImportModal,
        },
        {
          label: "Add",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openOfficesForm,
        },
      ],
    },
  ];
  const status = status_data?.status;

  const shouldHideButtons =
    status === "in_progress";
  const buttonShow = status === "completed";

  const filteredTableTop = tableTop.filter((item) => {
    if (item.type === "BUTTONS") {
      if (
        item.buttons?.some((b) => b.label === "Add" || b.label === "Import")
      ) {
        return !shouldHideButtons;
      }
      return buttonShow;
    }
    return true;
  });

  const tableTopView: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="is-size-4 has-text-weight-bold">Loco Pilots</p>,
    },
  ];

  const tableFooterConfig: SmartTableNewInterface.SmartTableNewFooterConfig[] = [
    { className: "is-1 p-2 is-3-mobile", footerType: "PAGE_SIZE_SELECT", footerFunction: () => null },
    { className: "is-5 p-5 is-9-mobile", footerType: "SHOW_ENTRIES", footerFunction: () => null },
    { className: "is-6 is-12-mobile", footerType: "PAGINATION", footerFunction: () => null },
    {
      className: "is-hidden",
      footerType: "FUNCTION",
      footerFunction: (_pageCount: any, setCurrentPage: any, _setPageSizeHandle: any, startIndex: any) => {
        setCurrentPageRef.current = setCurrentPage;
        if (!shouldRestorePageRef.current) {
          currentPageRef.current = Math.floor(startIndex / 10) + 1;
        }
        return null;
      },
    },
  ];

  return (
    <div className="sd-efl-input">
      <SmartTable
        columns={columns}
        data={tabData}
        tableTop={idIn || is_admin ? tableTopView : filteredTableTop}
        tableProps={{
          className: "is-hoverable is-bordered smart-hims-table",
          isResponsive: true,
          searchPlaceHolder: "Search",
        }}
        allowColumnSection={true}
        paginationProps={{ pageSize: 10 }}
        footerConfig={tableFooterConfig}
        // exportFileName="Asset Report"
        // exportTitle="Asset Report"
      />
    </div>
  );
};

export default SessionUsersTable;
